class Fade {
	constructor(el) {
		this.fade = el;

		if (!this.fade) return;

		// Порог в пикселях для показа fade
		this.scrollThreshold = 10;
		this.isVisible = false;

		this.init();
	}

	init() {
		this.bindEvents();
		this.updateVisibility();
	}

	bindEvents() {
		window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
		window.addEventListener('resize', this.handleResize.bind(this), { passive: true });
	}

	handleScroll() {
		this.updateVisibility();
	}

	handleResize() {
		this.updateVisibility();
	}

	updateVisibility() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		const shouldBeVisible = scrollTop > this.scrollThreshold;

		if (shouldBeVisible !== this.isVisible) {
			this.isVisible = shouldBeVisible;

			if (this.isVisible) {
				this.fade.classList.add('_visible');
			} else {
				this.fade.classList.remove('_visible');
			}
		}
	}
}

document.querySelectorAll('[data-fade]').forEach((el) => new Fade(el));
export default Fade;
